import { Col, Form, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import AppPageHeader from '@/components/_common/AppPageHeader';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { ListEmployeesQuery } from '@/core/domain/enterprise/Employees/Employees.types';

const EmployeesSelectedFilters: React.FC<
  ExtraFiltersProps<ListEmployeesQuery>
> = ({ setQueryParams, queryParams }) => {
  return (
    <AppPageHeader
      onSearch={(value: string) =>
        setQueryParams((prev) => ({ ...prev, name: value }))
      }
      extraFilters={
        <Form>
          <Row gutter={8}>
            <Col span={12}>
              <OrderExtraFilter
                value={queryParams?.order}
                onChange={(value) =>
                  setQueryParams((prev) => ({
                    ...prev,

                    order: value,
                  }))
                }
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
};

export default EmployeesSelectedFilters;
